import { useSupport } from '../../../../context/support/SupportContext';
import TicketList from './sections/TicketList/TicketList';
import TicketConsole from './sections/TicketConsole/TicketConsole';
import NewTicketForm from './sections/NewTicketForm/NewTicketForm';

const HelpdeskWorkspace = () => {
  const { selectedTicketId, selectedTicket, isNewTicketAction } = useSupport();

  return (
    <div className="flex flex-col md:flex-row bg-white border border-gray-200 md:rounded-2xl overflow-hidden shadow-sm h-[calc(100vh-210px)] min-h-[580px]">
      <TicketList />

      <div
        className={`flex-1 flex flex-col bg-white overflow-hidden ${
          selectedTicketId || isNewTicketAction ? 'flex' : 'hidden md:flex'
        }`}
      >
        {selectedTicketId && selectedTicket ? (
          <TicketConsole />
        ) : (
          <NewTicketForm />
        )}
      </div>
    </div>
  );
};

export default HelpdeskWorkspace;
